var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1SimCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 54h24V26H26v28zm14-3h-4v-6h4v6zm7 0h-4v-6h4v6zM36 29h4v6h-4v-6zm-7 0h4v6h-4v-6zm0 9h14v-9h4v13H29v-4zm0 7h4v6h-4v-6zm29.41-24.43l-10-10A2 2 0 0047 10H21a4.18 4.18 0 00-4 4v47a4.14 4.14 0 004 4h34a4.15 4.15 0 004-4V22a2 2 0 00-.59-1.43zM55 61H21V14h25.17L55 22.83V61z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_SIM_card.7fcaaea7.svg";
export { SvgH1SimCard as ReactComponent };